<template>
  <div class="operation-report-show-body-form-item flex flex-col">
    <div class="form-item-label aisea-text-16-700-dark-gray">
      {{ label }}
    </div>
    <template>
      <div class="form-item-value-unit flex aisea-text-16-400-dark-gray">
        <div class="form-item-value">{{ valueRead }}</div>
        <div class="form-item-value-unit flex items-center" v-show="hasUnit">
          {{ unitRead }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import isEmpty from "lodash/isEmpty";
import isString from "lodash/isString";
import mapKeys from "lodash/mapKeys";
import isObject from "lodash/isObject";

// 詳細用
export default {
  name: "FormItem",
  props: {
    label: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number],
      default: "",
    },
    unit: {
      type: String,
      default: "",
    },
    nullableLabel: {
      type: String,
      required: false,
    },
    isNullableChecked: {
      type: Boolean,
      default: false,
    },

    fallbackValue: {
      type: String,
      default: "-",
    },
    hasReportFormVersionItemValue: {
      type: Boolean,
      default: false,
    },
    selectOptions: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  computed: {
    valueRead() {
      const {
        label,
        value,
        nullableLabel,
        isNullableChecked,
        hasReportFormVersionItemValue,
        fallbackValue,
        hasLabelFromSelectOptions,
        labelFromSelectOptions,
      } = this;
      if (label === "" || label === null) return ""; // labelが空の場合は調整用のSPACEとみなし、valueを表示しない
      if (isNullableChecked) return nullableLabel;
      if (!hasReportFormVersionItemValue) return fallbackValue;
      if (hasLabelFromSelectOptions) return labelFromSelectOptions;
      return value;
    },
    unitRead() {
      const { unit, hasReportFormVersionItemValue } = this;
      if (!hasReportFormVersionItemValue) return ""; // Read の場合、データが無い場合は単位も表示しない
      return unit;
    },
    hasUnit() {
      return isString(this.unitRead) && !isEmpty(this.unitRead); // boolean
    },
    hasSelectOptions() {
      const { selectOptions } = this;
      return Array.isArray(selectOptions) && selectOptions.length > 0; // boolean
    },
    selectOptionMapByValue() {
      const selectOptionMapByValue = mapKeys(this.selectOptions, "value");
      return selectOptionMapByValue; // { [key: value]: SELECT_OPTION }
    },
    labelFromSelectOptions() {
      const { value, selectOptionMapByValue } = this;
      const selectOption = selectOptionMapByValue[value];
      if (!isObject(selectOption)) return undefined;
      return selectOption.label; // string | undefined
    },
    hasLabelFromSelectOptions() {
      const { hasSelectOptions, labelFromSelectOptions } = this;
      if (!hasSelectOptions) return false;
      return (
        isString(labelFromSelectOptions) && !isEmpty(labelFromSelectOptions)
      ); // boolean
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";

.operation-report-show-body-form-item {
  min-height: 90px;
  padding: 18px 0;
  row-gap: 4px;
}
</style>
